import { Component, effect, inject, input, output, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { EntityStatus } from '@core';
import { DeviceServiceV2 } from '@devices';
import { type NormalizedDeviceData } from '@devices';

@Component({
  imports: [
    MatIcon,
    MatSelectModule,
  ],
  selector: 'avs-li-device-selector',
  standalone: true,
  templateUrl: './device-selector.component.html',
})

export class DeviceSelectorComponent {
  changed = output<string>();
  filters = input<{ dataPoint?: string, location?: string, space?: string; }>({});
  value = input<string>();

  protected deviceService = inject(DeviceServiceV2);
  protected devices = signal<NormalizedDeviceData[]>([]);

  constructor() {
    effect(() => {
      this.deviceService.list(
        {
          filters: {
            ...this.filters(),
            ...{ status: [EntityStatus.Active, EntityStatus.Paused, EntityStatus.Deactivated] },
          },
        })
        .subscribe(({ data }) => {
          this.devices.set(data);
        });
    });
  }
}
